import { useRouter } from 'next/router';
import { FC, useEffect, useState } from 'react';
import { medicoUserStorage } from '~/utils/storage/ubieAppStorage';
import { useIsAppointmentPath } from '~/hooks/useIsAppointmentPath';

const CREATED_ANONYMOUS_KEY = 'created_anonymous';

// ローカルストレージにアカウントがない場合、ofroにリダイレクトして匿名アカウントを発行する
// ref https://www.notion.so/ubie-inc/13c6bbd4e00f806e8de1c3bdf8d943c8
export const MedicoUserAccount: FC<React.PropsWithChildren> = (props) => {
  const router = useRouter();
  const isAppointmentPath = useIsAppointmentPath();
  const [isShowDescription, setIsShowDescription] = useState(false);

  useEffect(() => {
    // 現時点では集患サポートのパスのみ処理する
    if (!isAppointmentPath) return;

    // ユーザが存在してる場合、アカウント発行しなくてよい
    const user = medicoUserStorage.get();
    if (user != null) return;

    // アカウント発行後だがユーザを読み込めなかったときに無限ループするのを防ぐために、チェックする。
    const currentUrl = new URL(window.location.href);
    if (currentUrl.searchParams.has(CREATED_ANONYMOUS_KEY))
      throw new Error('匿名アカウント発行済みのはずだが、ローカルストレージからユーザを取得できない');

    // ユーザが存在しない場合、medicoにリダイレクトして匿名アカウントを作成する
    // ローカルの場合、sushiroをmedico(ofro)と同じオリジンで動かしてないので、リダイレクトはしない
    if (process.env.NEXT_PUBLIC_APP_ENV === 'local') {
      setIsShowDescription(true);
    } else {
      currentUrl.searchParams.set(CREATED_ANONYMOUS_KEY, '1');
      const callbackPath = currentUrl.toString().replace(currentUrl.origin, '');

      const medicoUrl = [
        process.env.NEXT_PUBLIC_MEDICO_URL,
        '/for-same-origin-app/create-anonymous',
        `?callbackPath=${encodeURIComponent(callbackPath)}`,
      ].join('');

      router.push(medicoUrl);
    }
  }, [isAppointmentPath, router]);

  if (isShowDescription) {
    return (
      <div>
        ofro(ローカル)を立ち上げて、ローカルストレージの「medico-user」「ubie-auth」をsushiro(ローカル)のローカルストレージに追加してください
      </div>
    );
  } else {
    return <>{props.children}</>;
  }
};
